import { jsx } from "react/jsx-runtime";
import { SuspenseFallback } from "@tecnobit-srl/components-store";
import { Suspense, lazy, useMemo } from "react";
//#region src/use-consultants-list.tsx
var LazyConsultantsList = lazy(() => import("./consultants-list-CP7htCXc.js").then((n) => n.n).then((module) => ({ default: module.ConsultantsList })));
function ConsultantsList({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "consultants-list" }),
		children: /* @__PURE__ */ jsx(LazyConsultantsList, { ...props })
	});
}
function ConsultantsListContent({ ...props }) {
	return /* @__PURE__ */ jsx(Suspense, {
		fallback: /* @__PURE__ */ jsx(SuspenseFallback, { name: "consultants-list" }),
		children: /* @__PURE__ */ jsx(LazyConsultantsList, { ...props })
	});
}
var useConsultantsListContent = () => {
	return useMemo(() => ({ consultantsList: { component: ConsultantsListContent } }), []);
};
//#endregion
export { ConsultantsList, useConsultantsListContent };
